import ModalLoader from "../../assets/modal_loader.svg?react";
import HourGlassLoader from "../../assets/hourglass-half.svg?react";
import DatabaseLoader from "../../assets/database.svg?react";
import { LOADER_ID } from "../../common/utils/constants";
import React from "react";

interface Step {
    value: number;
    image: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    message: string;
    secondaryMessage?: string;
}

const BASE_STEPS: Step[] = [
    {
        value: 100,
        image: ModalLoader,
        message: "Generating Results",
        secondaryMessage:
            "Please do not close the browser or refresh the page while the results are being generated.",
    },
];

const AMC_QUERY_STEPS: Step[] = [
    {
        value: 100,
        image: ModalLoader,
        message: "Submitting Analysis & Query",
    },
];

const SNOWFLAKE_CONNECTOR_STEPS: Step[] = [
    {
        value: 100,
        image: HourGlassLoader,
        message: "Configuring Connector",
        secondaryMessage: "This may take up to 2 mins",
    },
];

const ADD_ACCOUNT: Step[] = [
    {
        value: 100,
        image: HourGlassLoader,
        message: "Authenticating Account",
        secondaryMessage: "This may take up to 1 min",
    },
];

const REFRESH_DATABASE_TABLES: Step[] = [
    {
        value: 100,
        image: HourGlassLoader,
        message: "Refreshing datasources",
    },
];

const SYNCING_DATABASES: Step[] = [
    {
        value: 100,
        image: DatabaseLoader,
        message: "Syncing Datasources",
        secondaryMessage:
            "Please wait while your databases sync. Do not exit or refresh the page while syncing.",
    },
];

export function getLoaderConfig(id) {
    switch (id) {
        case LOADER_ID.AMC_QUERY_CONVERSION_TRACKING:
        case LOADER_ID.AMC_QUERY_REACH_AND_FREQUENCY: {
            return {
                expectedTime: getExpectedTimeForLoader(id),
                steps: AMC_QUERY_STEPS,
            };
        }
        case LOADER_ID.CONFIGURE_CONNECTOR: {
            return {
                expectedTime: getExpectedTimeForLoader(id),
                steps: SNOWFLAKE_CONNECTOR_STEPS,
            };
        }
        case LOADER_ID.ADD_ACCOUNT: {
            return {
                expectedTime: getExpectedTimeForLoader(id),
                steps: ADD_ACCOUNT,
            };
        }
        case LOADER_ID.REFRESH_DATABASE_TABLES: {
            return {
                expectedTime: getExpectedTimeForLoader(id),
                steps: REFRESH_DATABASE_TABLES,
            };
        }
        case LOADER_ID.SYNCING_DATABASES: {
            return {
                expectedTime: getExpectedTimeForLoader(id),
                steps: SYNCING_DATABASES,
            };
        }
        default: {
            return {
                expectedTime: getExpectedTimeForLoader(id),
                steps: BASE_STEPS,
            };
        }
    }
}

export function getExpectedTimeForLoader(id) {
    switch (id) {
        case LOADER_ID.LOOKALIKE_MODELLING:
            return 120000;
        case LOADER_ID.CONFIGURE_CONNECTOR:
        case LOADER_ID.CONVERSION_TRACKING:
        case LOADER_ID.AMC_QUERY_CONVERSION_TRACKING:
        case LOADER_ID.AMC_QUERY_REACH_AND_FREQUENCY:
        case LOADER_ID.INVENTORY_FORCASTING_PLANNING:
        case LOADER_ID.AUDIENCE_OVERLAP:
            return 30000;
        case LOADER_ID.AUDIENCE_OVERLAP_MULTI:
        case LOADER_ID.CONVERSION_TRACKING_MULTI:
            return 60000;
        default:
            return 45000;
    }
}

/**
 * Calculate the active step based on current progress
 * @param steps
 * @param currentProgress
 * @returns
 */
export function getActiveStepIdx(steps: Step[], currentProgress: number) {
    // assuming steps are sorted in increasing order
    const activeStepIndex = steps.findIndex(
        (step) => currentProgress <= step.value,
    );
    if (activeStepIndex === -1) {
        // no match found, safe to assume last step
        return steps.length - 1;
    } else {
        return activeStepIndex;
    }
}
